import { NavLink } from "react-router";
import './Enquire.css'

export default function Enquire(){
    return(
        <div className="the-content">
            <div className="the-text">Want to find out more? Get in touch</div>
            <div className="the-button"><NavLink to='/Contact'>Contact us</NavLink></div>
        </div>
    )
}